import { Skeleton } from 'antd'
import { useEffect, useState } from 'react'
import { Navigate, useLocation, useParams } from 'react-router-dom'
import { getVirtualIpDraft } from '../../api'
import { virtualIpProjectsPath } from './virtualIpPaths'

/**
 * Old bookmarks `/virtual-ip-positioning` and `/virtual-ip-positioning/step-N`
 * redirect into the Project list (no project context) or the matching
 * project workflow when a draft can be resolved.
 */
export default function VirtualIpLegacyPositioningRedirect() {
  const { workspaceId = '' } = useParams()
  const location = useLocation()
  const [target, setTarget] = useState<string | null>(null)

  useEffect(() => {
    if (!workspaceId) return
    let cancelled = false
    const suffix = location.pathname.split('/virtual-ip-positioning')[1] || ''
    const stepMatch = suffix.match(/^\/(step-\d+|legacy\/[^/]+)/)
    const stepRoute = stepMatch?.[1]

    getVirtualIpDraft(workspaceId)
      .then((res) => {
        if (cancelled) return
        const projectId = res.data?.id
        if (!projectId) {
          setTarget(virtualIpProjectsPath(workspaceId))
          return
        }
        if (stepRoute) {
          setTarget(`/workspace/${workspaceId}/virtual-ip/projects/${projectId}/${stepRoute}`)
        } else {
          setTarget(`/workspace/${workspaceId}/virtual-ip/projects/${projectId}`)
        }
      })
      .catch(() => {
        if (!cancelled) setTarget(virtualIpProjectsPath(workspaceId))
      })

    return () => {
      cancelled = true
    }
  }, [workspaceId, location.pathname])

  if (!target) {
    return (
      <div className="tc-vip-page" data-testid="virtual-ip-legacy-redirect-loading">
        <Skeleton active paragraph={{ rows: 2 }} />
      </div>
    )
  }
  return <Navigate to={target} replace />
}
